<template lang="">
  <div class="flex-fill">
    <section id="banner" class="" style="background-image: url('static/img/default/banner-new.png'); background-size: cover; background-repeat: no-repeat; background-position: top right; ">
      <div class="container py-20">
        <div class="text-center">
          <span class="d-block text-white font-size-h2 font-weight-bolder mb-10">Ajukan pertanyaan, jawaban, dan terhubung dengan Anggota Sekar lainnya</span>
          <form @submit.prevent="startSearch()" class="d-flex position-relative w-75 px-lg-40 m-auto">
            <div class="input-group big-search">
              <!--begin::Icon-->
              <div class="input-group-prepend">
                <span class="input-group-text bg-white border-0 py-7 px-8">
                  <span class="svg-icon svg-icon-xl">
                    <!--begin::Svg Icon | path:/metronic/theme/html/demo3/dist/assets/media/svg/icons/General/Search.svg-->
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect x="0" y="0" width="24" height="24"></rect>
                        <path d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z" fill="#000000" fill-rule="nonzero" opacity="0.3"></path>
                        <path d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z" fill="#000000" fill-rule="nonzero"></path>
                      </g>
                    </svg>
                    <!--end::Svg Icon-->
                  </span>
                </span>
              </div>
              <!--end::Icon-->

              <!--begin::Input-->
              <input v-model="temp_bigSearch" type="text" class="form-control fc-custom h-auto border-0 py-7 px-1 font-size-h6" placeholder="Cari topic, vote, gallery atau informasi terkini ..." />
              <!--end::Input-->
            </div>
          </form>
        </div>
        <div id="pinned-div" v-if="pinned && pinned.length && !isSearch" class="row mt-20">
          <div v-for="(x, index) in pinned" :key="index + '-pinned'" class="col-12 col-lg-4 mb-3">
            <template v-if="x.type === 'gallery_folders'">
              <div class="pointer card card-stretch card-custom rounded-xl">
                <div class="card-body d-flex flex-column">
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="d-flex align-items-center">
                      <div class="symbol symbol-20 symbol-lg-30 symbol-circle mr-3">
                        <img alt="Pic" v-if="x.img_photo_created_by" :src="x.img_photo_created_by.url" />
                        <img alt="Pic" v-else src="static/img/default/no-profile-new.png" />
                      </div>
                      <span class="text-gray font-weight-bolder text-capitalize">{{ x.rel_created_by }}</span>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="d-flex align-items-center">
                        <i class="ri-pushpin-fill text-secondary mr-1"></i>
                        <span class="text-muted">pinned</span>
                      </div>
                      <a v-if="$_sys.isAllowed(permission.pin) || $_sys.isAllowed(permission.archive + '-' + x.post_type)" href="javascript:" tabindex="0" :ref="'option-pinned-' + index" :id="'option-pinned-' + index" class="ml-3 pointer">
                        <i class="ri-more-fill font-weight-bolder"></i>
                      </a>
                      <b-popover v-if="$_sys.isAllowed(permission.pin) || $_sys.isAllowed(permission.archive + '-' + x.post_type)" :target="'option-pinned-' + index" triggers="click blur">
                        <ul class="list-unstyled mb-0">
                          <li v-if="$_sys.isAllowed(permission.pin)" class="border-bottom pointer">
                            <div @click="removePin(x, 'gallery-folders')" class="d-flex">
                              <i class="ri-pushpin-fill ri-2x text-secondary mr-3"></i>
                              <div class="flex-fill">
                                <span class="font-weight-bold font-size-lg">Batalkan Pin</span>
                                <p>Konten akan dinonaktifkan dari bagian pinned post</p>
                              </div>
                            </div>
                          </li>
                          <li v-if="$_sys.isAllowed(permission.archive + '-' + x.post_type)" class="pt-3 pointer">
                            <div @click="archievePost(x)" class="d-flex">
                              <i class="ri-error-warning-fill ri-2x text-secondary mr-3"></i>
                              <div class="flex-fill">
                                <span class="font-weight-bold font-size-lg">Arsipkan</span>
                                <p class="mb-0">Konten mengandung spam atau text yang menyinggung SARA</p>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </b-popover>
                    </div>
                  </div>
                  <!-- ============ -->
                  <div @click="redirect(x.type, x)" class="d-flex flex-fill flex-column text-left">
                    <div>
                      <span class="d-block my-2 font-weight-light text-muted font-size-sm">{{ x.created_at | parse('longDateTime') }}</span>
                      <span class="font-size-lg font-weight-boldest">{{ x.name }}</span>
                      <div class="text-secondary font-size-sm text-line-1" style="word-break: break-all;">
                        <template v-for="kw in x.keywords">#{{ kw }}</template>
                      </div>
                    </div>
                    <div class="flex-fill position-relative mt-4">
                      <img v-if="x.img_cover" v-img-fb="x.img_cover" class="img-gallery-thumb" />
                      <img v-else src="static/img/default/no-photo.png" class="img-gallery-thumb" />
                      <div class="position-absolute" :style="{ 'z-index': '2', top: '0', right: '0', bottom: '0', left: '0', 'background-image': 'linear-gradient(0deg, rgb(255 255 255) 0%, rgba(0, 0, 0, 0) 50%)', 'background-size': 'auto 100%', 'background-repeat': 'no-repeat', 'background-position': 'center bottom' }">
                        &nbsp;
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="x.type === 'news'">
              <div class="pointer card card-stretch card-custom rounded-xl">
                <div class="card-body d-flex flex-column">
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="d-flex align-items-center">
                      <div class="symbol symbol-20 symbol-lg-30 symbol-circle mr-3">
                        <img alt="Pic" v-if="x.img_photo_created_by" :src="x.img_photo_created_by.url" />
                        <img alt="Pic" v-else src="static/img/default/no-profile-new.png" />
                      </div>
                      <span class="text-gray font-weight-bolder text-capitalize">{{ x.rel_created_by }}</span>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="d-flex align-items-center">
                        <i class="ri-pushpin-fill text-secondary mr-1"></i>
                        <span class="text-muted">pinned</span>
                      </div>
                      <a v-if="$_sys.isAllowed(permission.pin) || $_sys.isAllowed(permission.archive + '-' + x.post_type)" href="javascript:" tabindex="0" :ref="'option-pinned-' + index" :id="'option-pinned-' + index" class="ml-3 pointer">
                        <i class="ri-more-fill font-weight-bolder"></i>
                      </a>
                      <b-popover v-if="$_sys.isAllowed(permission.pin) || $_sys.isAllowed(permission.archive + '-' + x.post_type)" :target="'option-pinned-' + index" triggers="click blur">
                        <ul class="list-unstyled mb-0">
                          <li v-if="$_sys.isAllowed(permission.pin)" class="border-bottom pointer">
                            <div @click="removePin(x, 'news')" class="d-flex">
                              <i class="ri-pushpin-fill ri-2x text-secondary mr-3"></i>
                              <div class="flex-fill">
                                <span class="font-weight-bold font-size-lg">Batalkan Pin</span>
                                <p>Konten akan dinonaktifkan dari bagian pinned post</p>
                              </div>
                            </div>
                          </li>
                          <li v-if="$_sys.isAllowed(permission.archive + '-' + x.post_type)" class="pt-3 pointer">
                            <div @click="archievePost(x)" class="d-flex">
                              <i class="ri-error-warning-fill ri-2x text-secondary mr-3"></i>
                              <div class="flex-fill">
                                <span class="font-weight-bold font-size-lg">Arsipkan</span>
                                <p class="mb-0">Konten mengandung spam atau text yang menyinggung SARA</p>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </b-popover>
                    </div>
                  </div>
                  <!-- ============ -->
                  <div @click="redirect(x.type, x)" class="d-flex flex-fill flex-column text-left">
                    <div class="flex-fill">
                      <span class="d-block my-2 font-weight-light text-muted font-size-sm">{{ x.created_at | parse('longDateTime') }}</span>
                      <span class="font-size-lg font-weight-boldest">{{ x.title }}</span>
                      <div class="text-secondary font-size-sm text-line-1" style="word-break: break-all;">
                        <template v-for="kw in x.keywords">#{{ kw }}</template>
                      </div>
                      <div class="position-relative mt-4">
                        <p class="text-line-4" v-html="removeImgFeed(x.content)"></p>
                        <span class="text-secondary font-size-sm font-weight-bold">baca selengkapnya</span>
                      </div>
                    </div>
                    <div>
                      <hr class="" style="border-style:dashed;" />
                      <div class="d-flex align-items-center">
                        <div class="d-flex align-items-center mr-5">
                          <i class="ri-thumb-up-fill text-secondary mr-2 pb-1"></i>
                          <span class="font-weight-bold">{{ x.total_like }}</span>
                        </div>
                        <!-- <div class="d-flex align-items-center">
                          <i class="ri-chat-2-fill text-secondary mr-2"></i>
                          <span class="font-weight-bold">{{ x.total_comment }}</span>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="x.type === 'config_votings'">
              <div class="pointer card card-stretch card-custom rounded-xl">
                <div class="card-body d-flex flex-column">
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="d-flex align-items-center">
                      <div class="symbol symbol-20 symbol-lg-30 symbol-circle mr-3">
                        <img alt="Pic" v-if="x.img_photo_created_by" :src="x.img_photo_created_by.url" />
                        <img alt="Pic" v-else src="static/img/default/no-profile-new.png" />
                      </div>
                      <span class="text-gray font-weight-bolder text-capitalize">{{ x.rel_created_by }}</span>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="d-flex align-items-center">
                        <i class="ri-pushpin-fill text-secondary mr-1"></i>
                        <span class="text-muted">pinned</span>
                      </div>
                      <a v-if="$_sys.isAllowed(permission.pin) || $_sys.isAllowed(permission.archive + '-' + x.post_type)" href="javascript:" tabindex="0" :ref="'option-pinned-' + index" :id="'option-pinned-' + index" class="ml-3 pointer">
                        <i class="ri-more-fill font-weight-bolder"></i>
                      </a>
                      <b-popover v-if="$_sys.isAllowed(permission.pin) || $_sys.isAllowed(permission.archive + '-' + x.post_type)" :target="'option-pinned-' + index" triggers="click blur">
                        <ul class="list-unstyled mb-0">
                          <li v-if="$_sys.isAllowed(permission.pin)" class="border-bottom pointer">
                            <div @click="removePin(x, 'config-votings')" class="d-flex">
                              <i class="ri-pushpin-fill ri-2x text-secondary mr-3"></i>
                              <div class="flex-fill">
                                <span class="font-weight-bold font-size-lg">Batalkan Pin</span>
                                <p>Konten akan dinonaktifkan dari bagian pinned post</p>
                              </div>
                            </div>
                          </li>
                          <li v-if="$_sys.isAllowed(permission.archive + '-' + x.post_type)" class="pt-3 pointer">
                            <div @click="archievePost(x)" class="d-flex">
                              <i class="ri-error-warning-fill ri-2x text-secondary mr-3"></i>
                              <div class="flex-fill">
                                <span class="font-weight-bold font-size-lg">Arsipkan</span>
                                <p class="mb-0">Konten mengandung spam atau text yang menyinggung SARA</p>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </b-popover>
                    </div>
                  </div>
                  <!-- ============ -->
                  <div @click="redirect(x.type, x)" class="d-flex flex-fill flex-column text-left">
                    <div class="flex-fill">
                      <span class="d-block my-2 font-weight-light text-muted font-size-sm">{{ x.created_at | parse('longDateTime') }}</span>
                      <span class="font-size-lg font-weight-boldest">{{ x.name }}</span>
                      <div class="position-relative mt-4">
                        <p class="text-line-2" v-html="x.description"></p>
                        <ul class="list-unstyled">
                          <li v-for="(o, index) in x.options" :key="index + '-option-vote'" style="background-color: #f4f5f8" class="rounded py-3 px-2 mb-2">
                            <div class="text-line-1">{{ index + 1 }}. {{ o }}</div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div>
                      <hr class="" style="border-style:dashed;" />
                      <div class="text-italic">
                        <span class="font-weight-bolder text-secondary">{{ x.total_vote }}</span>
                        dari {{ x.total_participant }} member sudah memberikan vote
                      </div>
                      <div class="progress progress-xs w-100 mt-4">
                        <div class="progress-bar bg-info" role="progressbar" :style="{ width: (x.total_vote / x.total_participant) * 100 + '%' }"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="pointer card card-stretch card-custom rounded-xl">
                <div class="card-body d-flex flex-column">
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="d-flex align-items-center">
                      <div class="symbol symbol-20 symbol-lg-30 symbol-circle mr-3">
                        <img alt="Pic" v-if="x.img_photo_created_by" :src="x.img_photo_created_by.url" />
                        <img alt="Pic" v-else src="static/img/default/no-profile-new.png" />
                      </div>
                      <span class="text-gray font-weight-bolder text-capitalize">{{ x.rel_created_by }}</span>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="d-flex align-items-center">
                        <i class="ri-pushpin-fill text-secondary mr-1"></i>
                        <span class="text-muted">pinned</span>
                      </div>
                      <a v-if="$_sys.isAllowed(permission.pin) || $_sys.isAllowed(permission.archive + '-' + x.post_type)" href="javascript:" tabindex="0" :ref="'option-pinned-' + index" :id="'option-pinned-' + index" class="ml-3 pointer">
                        <i class="ri-more-fill font-weight-bolder"></i>
                      </a>
                      <b-popover v-if="$_sys.isAllowed(permission.pin) || $_sys.isAllowed(permission.archive + '-' + x.post_type)" :target="'option-pinned-' + index" triggers="click blur">
                        <ul class="list-unstyled mb-0">
                          <li v-if="$_sys.isAllowed(permission.pin)" class="border-bottom pointer">
                            <div @click="removePin(x, 'forums')" class="d-flex">
                              <i class="ri-pushpin-fill ri-2x text-secondary mr-3"></i>
                              <div class="flex-fill">
                                <span class="font-weight-bold font-size-lg">Batalkan Pin</span>
                                <p>Konten akan dinonaktifkan dari bagian pinned post</p>
                              </div>
                            </div>
                          </li>
                          <li v-if="$_sys.isAllowed(permission.archive + '-' + x.post_type)" class="pt-3 pointer">
                            <div @click="archievePost(x)" class="d-flex">
                              <i class="ri-error-warning-fill ri-2x text-secondary mr-3"></i>
                              <div class="flex-fill">
                                <span class="font-weight-bold font-size-lg">Arsipkan</span>
                                <p class="mb-0">Konten mengandung spam atau text yang menyinggung SARA</p>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </b-popover>
                    </div>
                  </div>
                  <!-- ============ -->
                  <div @click="redirect(x.type, x)" class="d-flex flex-fill flex-column text-left">
                    <div class="flex-fill">
                      <span class="d-block my-2 font-weight-light text-muted font-size-sm">{{ x.created_at | parse('longDateTime') }}</span>
                      <span class="font-size-lg font-weight-boldest">{{ x.title }}</span>
                      <div class="text-secondary font-size-sm font-weight-bold text-line-1" style="word-break: break-all;">
                        {{ x.rel_category_id }}
                      </div>
                      <div class="position-relative mt-4">
                        <p class="text-line-4" v-html="removeImgFeed(x.content)"></p>
                        <span class="text-secondary font-size-sm font-weight-bold">baca selengkapnya</span>
                      </div>
                    </div>
                    <div>
                      <hr class="" style="border-style:dashed;" />
                      <div class="d-flex align-items-center">
                        <div class="d-flex align-items-center mr-5">
                          <i class="ri-thumb-up-fill text-secondary mr-2 pb-1"></i>
                          <span class="font-weight-bold">{{ x.total_like }}</span>
                        </div>
                        <div class="d-flex align-items-center">
                          <i class="ri-chat-2-fill text-secondary mr-2"></i>
                          <span class="font-weight-bold">{{ x.total_comment }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </section>
    <section ref="content" v-if="!isSearch" id="content">
      <div class="container py-20">
        <div class="d-flex flex-row">
          <div class="flex-row-fluid">
            <div class="card card-custom rounded-xl">
              <div class="card-body">
                <h4 class="card-title text-secondary font-weight-bolder mb-0">Tambahkan Pertanyaan atau Bagikan Informasi ke Forum</h4>
                <hr />
                <div class="d-flex align-items-center mb-7 mt-2">
                  <div class="symbol symbol-20 symbol-lg-30 symbol-circle mr-3 border">
                    <img alt="Pic" v-if="$store.state.profile.img_photo_user" :src="$store.state.profile.img_photo_user.url" />
                    <img alt="Pic" v-else src="static/img/default/no-profile-new.png" />
                  </div>
                  <span class="text-gray font-weight-bolder text-capitalize">{{ $store.state.profile.fullname }}</span>
                </div>
                <div class="form-group">
                  <input v-model="newPost.title" type="text" class="form-control form-control-lg fc-custom font-weight-bolder" placeholder="Masukkan Judul" />
                </div>
                <template v-if="newPost.title !== null">
                  <s-input v-model="newPost.category_id" :item="{ type: 'select', validation: [], placeholder: 'Pilih Kategori', api: 'forum-categories', param: { active: true }, pointer: { label: 'name', code: 'id' } }" />
                  <editor-input v-model="newPost.content" :placeholder="'Jelaskan pertanyaan atau informasi ke forum ...'" />
                  <div class="form-group mt-5">
                    <label>Lampirkan Dokumen / Gambar</label>
                    <multi-upload :error="[]" :auth="false" v-model="newPost.child_data_forum_attachments" :attr="[{ accept: '.jpg, .jpeg, .png, .pdf' }, { limit: 5 }, { max: 5 }]" />
                  </div>
                </template>
                <hr />
                <button @click="postNew()" class="btn btn-secondary">
                  <i class="ri-add-fill"></i>
                  Post ke Forum
                </button>
              </div>
            </div>
            <div ref="inner-content" class="mt-10 position-relative" v-infinite-scroll="getMyFeed(false)" :infinite-scroll-disabled="loadingFeed" infinite-scroll-distance="10">
              <b-overlay :show="loadingFeed" no-wrap />
              <sequential-entrance fromBottom delay="100">
                <template v-for="(x, index) in myFeed">
                  <div :key="index + '-feeds'" class="card card-custom rounded-xl mb-5">
                    <div class="card-body d-flex flex-column">
                      <div class="d-flex align-items-center justify-content-between mb-3">
                        <div class="d-flex align-items-center">
                          <div class="symbol symbol-20 symbol-lg-30 symbol-circle mr-3">
                            <img alt="Pic" v-if="x.img_photo_created_by" :src="x.img_photo_created_by.url" />
                            <img alt="Pic" v-else src="static/img/default/no-profile-new.png" />
                          </div>
                          <span class="text-gray font-weight-bold text-capitalize">{{ x.rel_created_by }}</span>
                          <span class="text-muted font-weight-light ml-4 offcanvas-mobile">{{ x.created_at | parse('longDateTime') }}</span>
                        </div>
                        <div>
                          <a v-if="$_sys.isAllowed(permission.pin) || $_sys.isAllowed(permission.archive + '-' + x.post_type)" href="javascript:" tabindex="0" :ref="'option-feed-' + index" :id="'option-feed-' + index" class="ml-3 pointer">
                            <i class="ri-more-fill font-weight-bolder"></i>
                          </a>
                          <b-popover v-if="$_sys.isAllowed(permission.pin) || $_sys.isAllowed(permission.archive + '-' + x.post_type)" :target="'option-feed-' + index" triggers="click blur">
                            <ul class="list-unstyled mb-0">
                              <li v-if="$_sys.isAllowed(permission.pin) && !x.is_pinned" class="border-bottom pointer">
                                <div @click="removePin(x, x.post_type)" class="d-flex">
                                  <i class="ri-pushpin-fill ri-2x text-secondary mr-3"></i>
                                  <div class="flex-fill">
                                    <span class="font-weight-bold font-size-lg">Sematkan Post (Pin)</span>
                                    <p>Konten yang di sematkan akan tampil dalam baris sticky post.</p>
                                  </div>
                                </div>
                              </li>
                              <li v-if="$_sys.isAllowed(permission.pin) && x.is_pinned" class="border-bottom pointer">
                                <div @click="removePin(x, x.post_type)" class="d-flex">
                                  <i class="ri-pushpin-fill ri-2x text-secondary mr-3"></i>
                                  <div class="flex-fill">
                                    <span class="font-weight-bold font-size-lg">Batalkan Pin</span>
                                    <p>Konten akan dinonaktifkan dari bagian pinned post</p>
                                  </div>
                                </div>
                              </li>
                              <li v-if="$_sys.isAllowed(permission.archive + '-' + x.post_type)" class="pointer">
                                <div @click="archievePost(x)" class="d-flex">
                                  <i class="ri-error-warning-fill ri-2x text-secondary mr-3"></i>
                                  <div class="flex-fill">
                                    <span class="font-weight-bold font-size-lg">Arsipkan</span>
                                    <p class="mb-0">Konten mengandung spam atau text yang menyinggung SARA</p>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </b-popover>
                        </div>
                      </div>
                      <template v-if="x.post_type === 'gallery_folders'">
                        <div @click="redirect(x.post_type, x)" class="pointer ">
                          <span class="font-size-lg font-weight-boldest mb-3 d-block">{{ x.name }}</span>
                          <span class="d-block font-weight-bold">Galeri Album {{ x.category_name }} | Tahun {{ x.year }}</span>
                          <div class="text-secondary font-size-sm text-line-1" style="word-break: break-all;">
                            <template v-for="kw in x.keywords">#{{ kw }}</template>
                          </div>
                          <div class="flex-fill position-relative mt-4">
                            <img v-if="x.img_cover" v-img-fb="x.img_cover" class="img-voting-thumb-half" />
                            <img v-else src="static/img/default/no-photo.png" class="img-voting-thumb-half" />
                            <div class="position-absolute" :style="{ 'z-index': '2', top: '0', right: '0', bottom: '0', left: '0', 'background-image': 'linear-gradient(0deg, rgb(255 255 255) 0%, rgba(0, 0, 0, 0) 50%)', 'background-size': 'auto 100%', 'background-repeat': 'no-repeat', 'background-position': 'center bottom' }">
                              &nbsp;
                            </div>
                          </div>
                        </div>
                      </template>
                      <template v-else-if="x.post_type === 'forums'">
                        <div @click="redirect(x.post_type, x)" class="pointer d-flex justify-content-between align-items-start">
                          <div class="position-relative mt-4 mr-3">
                            <span class="font-size-lg font-weight-boldest">{{ x.title }}</span>
                            <p class="text-line-4 mt-2" v-html="x.content"></p>
                            <span class="text-secondary font-size-sm font-weight-bold">baca selengkapnya</span>
                          </div>
                          <!-- <div>
                            <img src="static/img/default/no-photo.png" class="img-feed-right rounded-xl" />
                          </div> -->
                        </div>
                      </template>
                      <template v-else-if="x.post_type === 'news'">
                        <div @click="redirect(x.post_type, x)" class="pointer d-flex justify-content-between align-items-start">
                          <div class="position-relative mt-4 mr-3">
                            <span class="font-size-lg font-weight-boldest">{{ x.title }}</span>
                            <p class="text-line-4 mt-2" v-html="removeImgFeed(x.content)"></p>
                            <span class="text-secondary font-size-sm font-weight-bold">baca selengkapnya</span>
                          </div>
                          <div class="offcanvas-mobile">
                            <img v-if="x.img_cover" v-img-fb="x.img_cover" src="static/img/default/no-photo.png" class="img-feed-right rounded-xl" />
                            <img v-else src="static/img/default/no-photo.png" class="img-feed-right rounded-xl" />
                          </div>
                        </div>
                      </template>
                      <template v-else-if="x.post_type === 'config_votings'">
                        <div @click="redirect(x.post_type, x)" class="pointer position-relative mt-4 mr-3">
                          <span class="font-size-lg font-weight-boldest">{{ x.name }}</span>
                          <p class="text-line-4 mt-2" v-html="x.description"></p>
                          <carousel
                            loop
                            autoplay
                            :spacePadding="15"
                            :autoplayTimeout="5000"
                            :speed="2000"
                            :perPageCustom="[
                              [480, 1],
                              [768, 3],
                              [1199, 3],
                            ]"
                            paginationActiveColor="var(--secondary-theme)"
                            :paginationSize="8"
                            :paginationPosition="'bottom'"
                          >
                            <slide v-for="(n, i) in x.options" :key="i + '-img-vote'" class="">
                              <div class="card card-custom mr-5 rounded-xl card-stretch">
                                <div class="card-body d-flex flex-column justify-content-between text-center">
                                  <div>
                                    <span class="d-block font-weight-bolder font-size-h6 text-muted mb-3" style="line-height:1.25">Pilihan #{{ i + 1 }}</span>
                                    <span class="d-block font-weight-bold font-size-h5 text-line-2 mb-5" style="line-height:1.25">{{ n.label }}</span>
                                    <img v-if="n.img_option" v-img-fb="n.img_option" class="img-news-thumb mb-0" />
                                    <img v-else src="static/img/default/no-photo.png" class="img-news-thumb mb-0" />
                                    <div class=" my-2 font-weight-light text-dark text-line-4">{{ n.description }}</div>
                                  </div>
                                  <div v-if="x.voting_type !== 'close'">
                                    <hr style="border-color: #B5B5C3; border-width:2px" />
                                    <div class="d-flex align-items-center justify-content-between">
                                      <div class="d-flex align-items-center">
                                        <div class="symbol symbol-45 symbol-light-primary mr-2">
                                          <span class="symbol-label">
                                            <i class="text-primary ri-pushpin-line ri-2x"></i>
                                          </span>
                                        </div>
                                        <div class="d-flex flex-column flex-grow-1 align-items-start">
                                          <span class="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1">{{ n.total_vote }}</span>
                                          <span class="text-muted font-weight-bold">suara</span>
                                        </div>
                                      </div>
                                      <div class="d-flex align-items-center">
                                        <div class="symbol symbol-45 symbol-light-warning mr-2">
                                          <span class="symbol-label">
                                            <i class="text-warning ri-percent-line ri-2x"></i>
                                          </span>
                                        </div>
                                        <div class="d-flex flex-column flex-grow-1 align-items-start">
                                          <span class="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1">{{ n.percent_vote }}%</span>
                                          <span class="text-muted font-weight-bold">persen</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </slide>
                          </carousel>
                        </div>
                        <!-- {{ x }} -->
                      </template>
                      <template v-else></template>
                      <div v-if="x.post_type != 'gallery_folders' && x.post_type != 'config_votings'">
                        <hr class="" style="border-style:dashed;" />
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="d-flex align-items-center flex-fill">
                            <div class="d-flex align-items-center mr-5">
                              <i class="ri-thumb-up-fill text-secondary mr-2 pb-1"></i>
                              <span class="font-weight-bold">{{ x.total_like }}</span>
                            </div>
                            <div v-if="x.post_type != 'news'" class="d-flex align-items-center">
                              <i class="ri-chat-2-fill text-secondary mr-2"></i>
                              <span class="font-weight-bold">{{ x.total_comment }}</span>
                            </div>
                          </div>
                          <div class="text-secondary font-size-sm text-line-1" style="word-break: break-all;">
                            <template v-for="kw in x.keywords">#{{ kw }}</template>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </sequential-entrance>
            </div>
          </div>
          <div class="flex-row-auto d-none d-lg-block w-250px w-xxl-300px ml-5">
            <template v-if="newsSide">
              <span class="section-title font-size-h4 mb-5">Berita Tentang Sekar</span>
              <div class="row pr-3">
                <div class="col-12 pr-0 mb-3" v-for="(x, index) in newsSide" :key="index + '-newsSide'">
                  <div @click="redirect('news', x)" class="pointer card card-custom rounded-xl">
                    <div class="card-body p-5">
                      <div class="font-weight-bolder text-capitalize text-line-1">{{ x.title }}</div>
                      <div class="text-secondary font-size-sm text-line-1" style="word-break: break-all;">
                        <template v-for="kw in x.keywords">#{{ kw }}</template>
                      </div>
                      <p class="text-line-4 mt-2" v-html="removeImgFeed(x.content)"></p>
                      <span class="d-block my-2 font-weight-light text-muted font-size-sm">{{ x.created_at | parse('longDateTime') }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <pre>{{gallerySide}}</pre> -->
              <button @click="redirect('all-news', null)" class="btn btn-secondary btn-block font-weight-bold mt-4 mb-10">
                Lihat Semua Berita
                <i class="ri-arrow-right-line"></i>
              </button>
            </template>
            <template v-if="gallerySide">
              <span class="section-title font-size-h4 mb-5">Galeri Foto</span>
              <div class="row pr-3">
                <div class="col-12 pr-0 mb-3" v-for="(x, index) in gallerySide" :key="index + '-gallerySide'">
                  <div @click="redirect('gallery_folders', x)" class="pointer card card-custom rounded-xl">
                    <div class="card-body p-5">
                      <div class="font-weight-bolder text-capitalize text-line-1">{{ x.name }}</div>
                      <p class="card-text mb-0">Galeri Album {{ x.rel_category_id }} tahun {{ x.year }}</p>
                      <div class="flex-fill position-relative mt-2">
                        <img v-if="x.img_cover" v-img-fb="x.img_cover" class="img-voting-thumb-half" />
                        <img v-else src="static/img/default/no-photo.png" class="img-voting-thumb-half" />
                        <div class="position-absolute d-flex flex-column justify-content-end" :style="{ 'z-index': '2', top: '0', right: '0', bottom: '0', left: '0', 'background-image': 'linear-gradient(0deg, rgb(255 255 255) 0%, rgba(0, 0, 0, 0) 75%)', 'background-size': 'auto 100%', 'background-repeat': 'no-repeat', 'background-position': 'center bottom' }">
                          <!-- <div class="font-weight-bolder text-capitalize text-line-1">{{ x.name }}</div>
                          <p class="card-text mb-0">{{ x.rel_category_id }}</p> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <pre>{{gallerySide}}</pre> -->
              <button @click="redirect('all-gallery', null)" class="btn btn-secondary btn-block font-weight-bold mt-4 mb-10">
                Lihat Semua Galeri
                <i class="ri-arrow-right-line"></i>
              </button>
            </template>
            <template v-if="voteSide">
              <span class="section-title font-size-h4 mb-5">Voting Sekar</span>
              <div class="row pr-3">
                <div class="col-12 pr-0 mb-3" v-for="(x, index) in voteSide" :key="index + '-voteSide'">
                  <div @click="redirect('config_votings', x)" class="pointer card card-custom rounded-xl">
                    <div class="card-body p-5">
                      <span class="font-size-lg font-weight-boldest">{{ x.name }}</span>
                      <div class="position-relative mt-4">
                        <p class="text-line-2" v-html="x.description"></p>
                        <ul class="list-unstyled">
                          <li v-for="(o, index) in x.options" :key="index + '-option-vote'" style="background-color: #f4f5f8" class="rounded py-3 px-2 mb-2">
                            <div class="text-line-1">{{ index + 1 }}. {{ o.label }}</div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <pre>{{gallerySide}}</pre> -->
              <button @click="redirect('all-vote', null)" class="btn btn-secondary btn-block font-weight-bold mt-4 mb-10">
                Lihat Semua Voting
                <i class="ri-arrow-right-line"></i>
              </button>
            </template>
          </div>
        </div>
      </div>
    </section>
    <section v-else ref="search-content" id="search-content">
      <div v-if="searchCategory.length && searchResult.length" class="container py-20">
        <div class="d-flex align-items-center mb-15">
          <h4 class="card-title font-weight-bolder mb-0">Hasil Pencarian</h4>
          <div class="d-flex align-items-center flex-fill ml-4">
            <span
              @click="
                getSearchFeed(true, { category: null })
                searchFilter = null
              "
              :class="searchFilter === null ? 'label-secondary font-weight-bolder' : 'label-outline-secondary text-secondary font-weight-bold'"
              class="label label-inline label-xl rounded-xl border-2 border-secondary pointer mr-3"
            >
              Semua Kategori
            </span>
            <template v-for="(c, index) in searchCategory">
              <span
                :key="index + '-category-search'"
                @click="
                  getSearchFeed(true, { category: c.code })
                  searchFilter = c.code
                "
                :class="searchFilter === c.code ? 'label-secondary font-weight-bolder' : 'label-outline-secondary text-secondary font-weight-bold'"
                class="label label-inline label-xl rounded-xl border-2 border-secondary pointer mr-3"
              >
                {{ c.name }}&emsp;{{ c.total }}
              </span>
            </template>
          </div>
        </div>
        <div ref="inner-content" class="mt-10 position-relative" v-infinite-scroll="getSearchFeed(false)" :infinite-scroll-disabled="loadingFeed" infinite-scroll-distance="10">
          <b-overlay :show="loadingFeed" no-wrap />
          <sequential-entrance fromBottom delay="100">
            <template v-for="(x, index) in searchResult">
              <div :key="index + '-feeds'" class="card card-custom rounded-xl mb-5">
                <div class="card-body d-flex flex-column">
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="d-flex align-items-center">
                      <div class="symbol symbol-20 symbol-lg-30 symbol-circle mr-3">
                        <img alt="Pic" v-if="x.img_photo_created_by" :src="x.img_photo_created_by.url" />
                        <img alt="Pic" v-else src="static/img/default/no-profile-new.png" />
                      </div>
                      <span class="text-gray font-weight-bold text-capitalize">{{ x.rel_created_by }}</span>
                      <span class="text-muted font-weight-light ml-4 offcanvas-mobile">{{ x.created_at | parse('longDateTime') }}</span>
                    </div>
                    <div>
                      <a v-if="$_sys.isAllowed(permission.pin) || $_sys.isAllowed(permission.archive + '-' + x.post_type)" href="javascript:" tabindex="0" :ref="'option-feed-' + index" :id="'option-feed-' + index" class="ml-3 pointer">
                        <i class="ri-more-fill font-weight-bolder"></i>
                      </a>
                      <b-popover v-if="$_sys.isAllowed(permission.pin) || $_sys.isAllowed(permission.archive + '-' + x.post_type)" :target="'option-feed-' + index" triggers="click blur">
                        <ul class="list-unstyled mb-0">
                          <li v-if="$_sys.isAllowed(permission.pin) && !x.is_pinned" class="border-bottom pointer">
                            <div @click="removePin(x, x.post_type)" class="d-flex">
                              <i class="ri-pushpin-fill ri-2x text-secondary mr-3"></i>
                              <div class="flex-fill">
                                <span class="font-weight-bold font-size-lg">Sematkan Post (Pin)</span>
                                <p>Konten yang di sematkan akan tampil dalam baris sticky post.</p>
                              </div>
                            </div>
                          </li>
                          <li v-if="$_sys.isAllowed(permission.pin) && x.is_pinned" class="border-bottom pointer">
                            <div @click="removePin(x, x.post_type)" class="d-flex">
                              <i class="ri-pushpin-fill ri-2x text-secondary mr-3"></i>
                              <div class="flex-fill">
                                <span class="font-weight-bold font-size-lg">Batalkan Pin</span>
                                <p>Konten akan dinonaktifkan dari bagian pinned post</p>
                              </div>
                            </div>
                          </li>
                          <li v-if="$_sys.isAllowed(permission.archive + '-' + x.post_type)" class="pointer">
                            <div @click="archievePost(x)" class="d-flex">
                              <i class="ri-error-warning-fill ri-2x text-secondary mr-3"></i>
                              <div class="flex-fill">
                                <span class="font-weight-bold font-size-lg">Arsipkan</span>
                                <p class="mb-0">Konten mengandung spam atau text yang menyinggung SARA</p>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </b-popover>
                    </div>
                  </div>
                  <template v-if="x.post_type === 'gallery_folders'">
                    <div @click="redirect(x.post_type, x)" class="pointer ">
                      <span class="font-size-lg font-weight-boldest mb-3 d-block">{{ x.name }}</span>
                      <span class="d-block font-weight-bold">Galeri Album {{ x.category_name }} | Tahun {{ x.year }}</span>
                      <div class="text-secondary font-size-sm text-line-1" style="word-break: break-all;">
                        <template v-for="kw in x.keywords">#{{ kw }}</template>
                      </div>
                      <div class="flex-fill position-relative mt-4">
                        <img v-if="x.img_cover" v-img-fb="x.img_cover" class="img-voting-thumb-half" />
                        <img v-else src="static/img/default/no-photo.png" class="img-voting-thumb-half" />
                        <div class="position-absolute" :style="{ 'z-index': '2', top: '0', right: '0', bottom: '0', left: '0', 'background-image': 'linear-gradient(0deg, rgb(255 255 255) 0%, rgba(0, 0, 0, 0) 50%)', 'background-size': 'auto 100%', 'background-repeat': 'no-repeat', 'background-position': 'center bottom' }">
                          &nbsp;
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="x.post_type === 'forums'">
                    <div @click="redirect(x.post_type, x)" class="pointer d-flex justify-content-between align-items-start">
                      <div class="position-relative mt-4 mr-3">
                        <span class="font-size-lg font-weight-boldest">{{ x.title }}</span>
                        <p class="text-line-4 mt-2" v-html="x.content"></p>
                        <span class="text-secondary font-size-sm font-weight-bold">baca selengkapnya</span>
                      </div>
                      <!-- <div>
                            <img src="static/img/default/no-photo.png" class="img-feed-right rounded-xl" />
                          </div> -->
                    </div>
                  </template>
                  <template v-else-if="x.post_type === 'news'">
                    <div @click="redirect(x.post_type, x)" class="pointer d-flex justify-content-between align-items-start">
                      <div class="position-relative mt-4 mr-3">
                        <span class="font-size-lg font-weight-boldest">{{ x.title }}</span>
                        <p class="text-line-4 mt-2" v-html="removeImgFeed(x.content)"></p>
                        <span class="text-secondary font-size-sm font-weight-bold">baca selengkapnya</span>
                      </div>
                      <div class="offcanvas-mobile">
                        <img v-if="x.img_cover" v-img-fb="x.img_cover" src="static/img/default/no-photo.png" class="img-feed-right rounded-xl" />
                        <img v-else src="static/img/default/no-photo.png" class="img-feed-right rounded-xl" />
                      </div>
                    </div>
                  </template>
                  <template v-else-if="x.post_type === 'config_votings'">
                    <div @click="redirect(x.post_type, x)" class="pointer position-relative mt-4 mr-3">
                      <span class="font-size-lg font-weight-boldest">{{ x.name }}</span>
                      <p class="text-line-4 mt-2" v-html="x.description"></p>
                      <carousel
                        loop
                        autoplay
                        :spacePadding="15"
                        :autoplayTimeout="5000"
                        :speed="2000"
                        :perPageCustom="[
                          [480, 1],
                          [768, 3],
                          [1199, 3],
                        ]"
                        paginationActiveColor="var(--secondary-theme)"
                        :paginationSize="8"
                        :paginationPosition="'bottom'"
                      >
                        <slide v-for="(n, i) in x.options" :key="i + '-img-vote'" class="">
                          <div class="card card-custom mr-5 rounded-xl card-stretch">
                            <div class="card-body d-flex flex-column justify-content-between text-center">
                              <div>
                                <span class="d-block font-weight-bolder font-size-h6 text-muted mb-3" style="line-height:1.25">Pilihan #{{ i + 1 }}</span>
                                <span class="d-block font-weight-bold font-size-h5 text-line-2 mb-5" style="line-height:1.25">{{ n.label }}</span>
                                <img v-if="n.img_option" v-img-fb="n.img_option" class="img-news-thumb mb-0" />
                                <img v-else src="static/img/default/no-photo.png" class="img-news-thumb mb-0" />
                                <div class=" my-2 font-weight-light text-dark text-line-4">{{ n.description }}</div>
                              </div>
                              <div v-if="x.voting_type !== 'close'">
                                <hr style="border-color: #B5B5C3; border-width:2px" />
                                <div class="d-flex align-items-center justify-content-between">
                                  <div class="d-flex align-items-center">
                                    <div class="symbol symbol-45 symbol-light-primary mr-2">
                                      <span class="symbol-label">
                                        <i class="text-primary ri-pushpin-line ri-2x"></i>
                                      </span>
                                    </div>
                                    <div class="d-flex flex-column flex-grow-1 align-items-start">
                                      <span class="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1">{{ n.total_vote }}</span>
                                      <span class="text-muted font-weight-bold">suara</span>
                                    </div>
                                  </div>
                                  <div class="d-flex align-items-center">
                                    <div class="symbol symbol-45 symbol-light-warning mr-2">
                                      <span class="symbol-label">
                                        <i class="text-warning ri-percent-line ri-2x"></i>
                                      </span>
                                    </div>
                                    <div class="d-flex flex-column flex-grow-1 align-items-start">
                                      <span class="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1">{{ n.percent_vote }}%</span>
                                      <span class="text-muted font-weight-bold">persen</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </slide>
                      </carousel>
                    </div>
                    <!-- {{ x }} -->
                  </template>
                  <template v-else></template>
                  <div v-if="x.post_type != 'gallery_folders' && x.post_type != 'config_votings'">
                    <hr class="" style="border-style:dashed;" />
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="d-flex align-items-center flex-fill">
                        <div class="d-flex align-items-center mr-5">
                          <i class="ri-thumb-up-fill text-secondary mr-2 pb-1"></i>
                          <span class="font-weight-bold">{{ x.total_like }}</span>
                        </div>
                        <div v-if="x.post_type != 'news'" class="d-flex align-items-center">
                          <i class="ri-chat-2-fill text-secondary mr-2"></i>
                          <span class="font-weight-bold">{{ x.total_comment }}</span>
                        </div>
                      </div>
                      <div class="text-secondary font-size-sm text-line-1" style="word-break: break-all;">
                        <template v-for="kw in x.keywords">#{{ kw }}</template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </sequential-entrance>
        </div>
      </div>
      <div v-else class="container py-20">
        <template v-if="!loadingFeed">
          <h4 class="card-title font-weight-bolder mb-0">Tidak ada hasil untuk kata kunci "{{ bigSearch }}"</h4>
        </template>
      </div>
    </section>
    <b-modal :id="'archive-modal'" hide-footer hide-header centered size="md">
      <h4 class="text-secondary font-weight-bolder mb-5">Alasan Pengarsipan / Report</h4>
      <div class="alert alert-custom gutter-b px-4 py-2" style="background-color: #f3f6f9;" role="alert">
        <div class="alert-icon alert-icon-top">
          <i class="ri-notification-fill"></i>
        </div>
        <div class="alert-text">
          <p class="mb-0">
            Postingan yang diarsipkan / report tidak akan ditampilkan di Beranda Forum
          </p>
        </div>
      </div>
      <div class="d-flex align-items-center mb-2">
        <label class="mb-0 font-weight-bolder" for="">Deskripsikan Alasan</label>
        <span class="label label-light-danger label-pill label-inline label-sm ml-2">wajib</span>
      </div>
      <div class="form-group mb-0">
        <textarea v-model="reportPost.description" class="form-control fc-custom mock-disabled" rows="3"></textarea>
        <!-- <input v-model="reportDesc" type="text" placeholder="ketikkan link url youtube disini ..." class="form-control fc-custom mock-disabled" /> -->
        <div class="nowrap mt-3">
          <button @click="reportSend()" class="btn btn-danger font-size-sm font-weight-bold">
            <i class="ri-archive-fill"></i>
            Arsipkan
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'beranda-landing',
  props: ['configs'],
  data () {
    return {
      isLoading: true,
      pinned: null,
      newPost: {
        title: null,
        content: null,
        category_id: null,
        child_data_forum_attachments: []
      },
      permission: {
        archive: 'archive',
        pin: 'pin-unpin-content'
      },
      loadingFeed: true,
      pageFeed: 0,
      totalPageFeed: 1,
      myFeed: [],
      reportPost: {
        id: null,
        description: null
      },
      gallerySide: null,
      voteSide: null,
      newsSide: null,
      temp_bigSearch: null,
      bigSearch: null,
      isSearch: false,
      searchCategory: [],
      searchResult: [],
      searchFilter: null,
      pageSearchFeed: 0,
      totalPageSearchFeed: 1
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getAPI (method, api, param, obj = null) {
      return this.$_api[method](api, param)
        .then((res) => {
          return obj ? res[obj] || res.data : res.data
        })
        .catch((err) => {
          this.$_alert.error(err)
        })
    },
    async getData () {
      this.pinned = await this.getAPI('get', 'updates/pinned-contents/list')
      this.gallerySide = await this.getAPI('get', 'updates/gallery-folders/list', { limit: 3 })
      this.voteSide = await this.getAPI('get', 'updates/config-votings/list', { limit: 3 })
      this.newsSide = await this.getAPI('get', 'updates/news/list', { limit: 3 })
      this.getMyFeed()
      this.isLoading = false
    },
    async removePin (data, api) {
      let pinunpin = await this.getAPI('post', api + '/pin-unpin', data)
      if (pinunpin) {
        this.pinned = await this.getAPI('get', 'updates/pinned-contents/list')
        if (pinunpin.is_pinned) {
          this.$scrollTo('#banner', 2000)
          this.$_alert.success('Berhasil disematkan')
        } else {
          this.$_alert.success('Berhasil membatalkan sematan')
        }
        data.is_pinned = !data.is_pinned
      }
    },
    archievePost (data) {
      this.reportPost = Object.assign({}, { id: data.id, description: null, type: data.post_type || data.type })
      this.$bvModal.show('archive-modal')
    },
    reportSend () {
      this.$_api
        .post(this.reportPost.type + '/archive', this.reportPost)
        .then((res) => {
          this.$_alert.success('Postingan berhasil diarsipkan')
          this.$bvModal.hide('archive-modal')
          this.pageFeed = 0
          this.getMyFeed(true)
        })
        .catch((err) => {
          this.$_alert.error(err)
        })
    },
    async postNew () {
      this.isLoading = true
      let res = await this.getAPI('post', 'updates/forums/create', this.newPost, 'message')
      if (res) {
        this.$_alert.success(null, res)
        this.newPost = Object.assign(
          {},
          {
            title: null,
            content: null,
            category_id: null,
            child_data_forum_attachments: []
          }
        )
        this.pageFeed = 0
        this.getMyFeed(true)
      }
      this.isLoading = false
    },
    getMyFeed (reset = false, gFilter = {}) {
      if (this.pageFeed < this.totalPageFeed) {
        this.pageFeed++
        let filter = {
          ...{
            limit: 15,
            page: this.pageFeed,
            sort_by: 'created_at'
          },
          ...gFilter
        }
        this.loadingFeed = true
        this.$_api
          .list('updates/timeline', filter)
          .then((res) => {
            this.loadingFeed = false
            if (!reset) this.myFeed = [...this.myFeed, ...res.data]
            else this.myFeed = res.data
            this.totalPageFeed = res.totalPage
          })
          .catch((err) => {
            this.loadingFeed = false
            this.$_alert.error(err)
          })
      }
    },
    getSearchFeed (reset = false, gFilter = {}) {
      if (reset) {
        this.pageSearchFeed = 0
        this.totalPageSearchFeed = 1
      }
      if (this.pageSearchFeed < this.totalPageSearchFeed) {
        this.pageSearchFeed++
        let filter = {
          ...{
            limit: 15,
            page: this.pageSearchFeed,
            sort_by: 'created_at',
            search: this.bigSearch
          },
          ...gFilter
        }
        this.loadingFeed = true
        this.$_api
          .get('updates/timeline/search', filter)
          .then((res) => {
            this.loadingFeed = false
            this.searchCategory = res.category
            if (!reset) this.searchResult = [...this.searchResult, ...res.data]
            else this.searchResult = res.data
            this.totalPageSearchFeed = res.totalPage
          })
          .catch((err) => {
            this.loadingFeed = false
            this.$_alert.error(err)
          })
      }
    },
    removeImgFeed (e) {
      return e.replace(/<img[^>]*>/g, '').replace(/<br[^>]*>/g, '')
    },
    startSearch () {
      if (this.temp_bigSearch) {
        this.isSearch = true
        this.bigSearch = this.temp_bigSearch
        this.getSearchFeed(true)
      } else {
        this.isSearch = false
        this.bigSearch = null
        this.searchFilter = null
        this.searchResult = []
        this.searchCategory = []
      }
      // this.pageFeed = 0
      // this.getMyFeed(true, { search: this.bigSearch })
      // var element = this.$refs['inner-content']
      // this.$scrollTo(element, 100, { offset: -100 })
    },
    redirect (e, data) {
      let target = null
      let params = {}
      switch (e) {
        case 'news':
          target = 'sekar-news'
          params = { pid: data.id, code: data.code }
          break
        case 'gallery_folders':
          target = 'sekar-gallery'
          params = { pid: data.id, code: data.code }
          break
        case 'config_votings':
          target = 'sekar-vote'
          params = { pid: data.id, code: data.code }
          break
        case 'forums':
          target = 'sekar-forum'
          params = { pid: data.id, code: data.code }
          break
        case 'all-news':
          target = 'all-news'
          params = {}
          break
        case 'all-gallery':
          target = 'all-gallery'
          params = {}
          break
        case 'all-vote':
          target = 'all-vote'
          params = {}
          break
        default:
          target = null
          break
      }
      if (target) {
        this.$router.push({ name: target, query: params })
      }
    }
  }
}
</script>
<style lang="">
  .section-title {
    display: block;
    position: relative;
    font-weight: 600;
    padding-left: 55px;
  }
  .section-title:before {
    content: '';
    position: absolute;
    left: 0;
    top: calc(50% - 1px);
    width: 35px;
    height: 1px;
    border-top: 4px solid var(--secondary-theme);
  }
  .big-search .fc-custom {
    border-radius: 0 48px 48px 0 !important;
  }
  .big-search .input-group-prepend .input-group-text {
    border-radius: 48px 0 0 48px !important;
  }
  .img-voting-thumb-half {
    width: 100%;
    aspect-ratio: 1 / 0.5;
    /* border-radius: 23px; */
    border-radius: 23px 23px 0 0;
    object-fit: cover;
    object-position: top;
  }
  .img-feed-right {
    width: 200px;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    object-position: center;
  }
  .img-news-thumb {
    width: 100%;
    aspect-ratio: 1 / 1;
    border-radius: 23px;
    object-fit: cover;
  }
  .img-gallery-thumb {
    width: 100%;
    border-radius: 23px;
    object-fit: cover;
  }
</style>



// WEBPACK FOOTER //
// src/landing-page/beranda.vue